(() => {
  'use strict';
  const $ = selector => document.querySelector(selector);
  const $$ = selector => [...document.querySelectorAll(selector)];

  // Interface uniquement : aucune adresse ou identité n’est envoyée ou stockée.
  $$('[data-signup]').forEach(form => {
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      form.querySelector('.form-feedback').textContent = 'Formulaire renseigné. Votre inscription n’a pas été envoyée : service d’envoi [À COMPLÉTER].';
    });
  });

  const banner = $('.cookie-banner');
  const preferences = $('.cookie-dialog');
  const preferenceForm = $('#cookie-preferences');
  let privacyPromise;
  function privacyAPI(){
    if(window.Shopify?.customerPrivacy)return Promise.resolve(window.Shopify.customerPrivacy);
    if(!privacyPromise)privacyPromise=new Promise((resolve,reject)=>{
      if(!window.Shopify?.loadFeatures){reject(new Error('Service de confidentialité indisponible. Réessayez après actualisation.'));return;}
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>error?reject(new Error('Impossible de charger vos préférences.')):resolve(window.Shopify.customerPrivacy));
    }).catch(error=>{privacyPromise=null;throw error;});
    return privacyPromise;
  }
  const refreshLock=()=>document.body.classList.toggle('dialog-open',$$('dialog').some(d=>d.open));
  const privacyError=error=>$$('.privacy-status').forEach(n=>n.textContent=error.message);
  async function saveChoice(analytics,marketing){
    const buttons=$$('.cookie-actions button,#cookie-preferences button[type="submit"]');buttons.forEach(b=>b.disabled=true);
    try{const api=await privacyAPI();await new Promise((resolve,reject)=>{
      const timeout=setTimeout(()=>reject(new Error('Le choix n’a pas pu être confirmé. Réessayez.')),10000);
      api.setTrackingConsent({analytics,marketing,preferences:false,sale_of_data:false},()=>{clearTimeout(timeout);resolve();});
    });banner.hidden=true;if(preferences.open)preferences.close();refreshLock();$$('.privacy-status').forEach(n=>n.textContent='');}
    catch(error){privacyError(error);}finally{buttons.forEach(b=>b.disabled=false);}
  }
  if(banner&&preferences&&preferenceForm){
    privacyAPI().then(api=>{const c=api.currentVisitorConsent();banner.hidden=Boolean(c.analytics&&c.marketing);}).catch(error=>{banner.hidden=false;privacyError(error);});
    $$('[data-consent]').forEach(b=>b.addEventListener('click',()=>saveChoice(b.dataset.consent==='all',b.dataset.consent==='all')));
    $$('[data-cookie-settings]').forEach(b=>b.addEventListener('click',async()=>{
      preferences.showModal();refreshLock();
      try{const c=(await privacyAPI()).currentVisitorConsent();preferenceForm.elements.analytics.checked=c.analytics==='yes';preferenceForm.elements.marketing.checked=c.marketing==='yes';}catch(error){privacyError(error);}
    }));
    $('[data-cookie-close]').addEventListener('click',()=>preferences.close());preferences.addEventListener('close',refreshLock);
    preferenceForm.addEventListener('submit',e=>{e.preventDefault();saveChoice(preferenceForm.elements.analytics.checked,preferenceForm.elements.marketing.checked);});
  }

  const withdrawalForm = $('#withdrawal-form');
  if (withdrawalForm) {
    const start = $('#withdrawal-start');
    const confirmation = $('#withdrawal-confirm');
    const receipt = $('#withdrawal-receipt');
    const name = $('#withdrawal-name');
    const order = $('#withdrawal-order');
    start.addEventListener('click', () => {
      start.hidden = true;
      receipt.hidden = true;
      withdrawalForm.hidden = false;
      name.focus();
    });
    [name, order].forEach(input => input.addEventListener('input', () => input.setCustomValidity('')));
    withdrawalForm.addEventListener('submit', event => {
      event.preventDefault();
      for (const input of [name, order]) input.setCustomValidity(input.value.trim() ? '' : 'Veuillez renseigner ce champ.');
      if (!withdrawalForm.reportValidity()) return;
      $('#withdrawal-summary').textContent = `${name.value.trim()} · Commande n° ${order.value.trim()}`;
      withdrawalForm.hidden = true;
      confirmation.hidden = false;
      $('#withdrawal-confirm-title').focus();
    });
    $('#withdrawal-edit').addEventListener('click', () => {
      confirmation.hidden = true;
      withdrawalForm.hidden = false;
      name.focus();
    });
    $('#withdrawal-submit').addEventListener('click', () => {
      confirmation.hidden = true;
      receipt.textContent = 'Votre demande est préparée sur cet appareil. Réception par le vendeur et accusé de réception : [À COMPLÉTER]. Aucune demande n’a été transmise. Pour exercer votre droit, envoyez votre décision au vendeur via un canal de contact valide.';
      receipt.hidden = false;
      receipt.focus();
      withdrawalForm.reset();
      $('#withdrawal-summary').textContent = '';
      start.hidden = false;
    });
  }
})();

// Conserve le thème non publié lors de la navigation dans un aperçu Shopify.
(() => {const current=new URL(location.href);const preview=current.searchParams.get('preview_theme_id');if(!preview)return;document.querySelectorAll('a[href]').forEach(a=>{const url=new URL(a.href,location.href);if(url.origin===location.origin){url.searchParams.set('preview_theme_id',preview);a.href=url.href;}});})();
